import { TbWorldSearch } from 'react-icons/tb';
import { MdDesignServices } from 'react-icons/md';
import { FaCode } from 'react-icons/fa6';
import { SiConstruct3 } from 'react-icons/si';
import '../assets/style/services.scss';

const Services = () => (
  <div className="service">
    {/* <h1 className="solid-underline">Services</h1> */}
    <div className="service-block">
      <div className="service-box">
        <h2>Development</h2>
        <span><i className="fa fa-gamepad" aria-hidden="true"><FaCode /></i></span>
        <p>
          &#x2022; Expert coding for tailored software solutions.
          <br />
          &#x2022; Scalable and reliable development services.
          <br />
          &#x2022; Customized applications to meet your needs.
          <br />
          &#x2022; Turn your ideas into functional realities.
        </p>
      </div>
      <div className="service-box">
        <h2>Design</h2>
        <span><i className="fa fa-cutlery" aria-hidden="true"><MdDesignServices /></i></span>
        <p>
          &#x2022; Captivating designs that leave a mark.
          <br />
          &#x2022; Enhancing your brand&apos;s identity visually.
          <br />
          &#x2022; Creative and eye-catching graphic solutions.
          <br />
          &#x2022; Designing for both aesthetics and usability.
        </p>
      </div>
      <div className="service-box">
        <h2>UI/UX</h2>
        <span><i className="fa fa-laptop" aria-hidden="true"><SiConstruct3 /></i></span>
        <p>
          &#x2022; Intuitive and modern interfaces for seamless interactions.
          <br />
          &#x2022; User-centric design approach for better experiences.
          <br />
          &#x2022; Streamlined navigation for improved usability.
          <br />
          &#x2022; Enhancing customer satisfaction through UX optimization.
        </p>
      </div>
      <div className="service-box">
        <h2>SEO</h2>
        <span><i className="fa fa-repeat" aria-hidden="true"><TbWorldSearch /></i></span>
        <p>
          &#x2022; Boosting online visibility and reach.
          <br />
          &#x2022; Driving organic traffic with proven strategies.
          <br />
          &#x2022; Keyword optimization for better search rankings.
          <br />
          &#x2022; Increasing website&apos;s visibility and conversion rates.
        </p>
      </div>
    </div>
  </div>
);

export default Services;
